var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rank" }, [
    _c("h4", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
    _c(
      "ul",
      {
        staticClass: "list",
        style: {
          height: _vm.height ? `${_vm.height}px` : "auto",
          overflow: "auto",
          "text-align": "center",
        },
      },
      [
        _vm.subTitle
          ? _c(
              "li",
              [
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c("a-col", { attrs: { span: 4 } }, [_vm._v("排名")]),
                    _c("a-col", { attrs: { span: 6 } }, [
                      _vm._v(
                        "\n          " + _vm._s(_vm.subTitle[0]) + "\n        "
                      ),
                    ]),
                    _c("a-col", { attrs: { span: 4 } }, [
                      _vm._v(
                        "\n          " + _vm._s(_vm.subTitle[1]) + "\n        "
                      ),
                    ]),
                    _c("a-col", { attrs: { span: 4 } }, [
                      _vm._v(
                        "\n          " + _vm._s(_vm.subTitle[2]) + "\n        "
                      ),
                    ]),
                    _c(
                      "a-col",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.subTitle[3],
                            expression: "subTitle[3]",
                          },
                        ],
                        attrs: { span: 6 },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.subTitle[3]) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "li",
            { key: index },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c("a-col", { attrs: { span: 4 } }, [
                    _c("span", { class: index < 3 ? "active" : null }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                  ]),
                  _c("a-col", { attrs: { span: 6 } }, [
                    _vm._v("\n          " + _vm._s(item.name) + "\n        "),
                  ]),
                  _c("a-col", { attrs: { span: 4 } }, [
                    _vm._v("\n          " + _vm._s(item.total) + "\n        "),
                  ]),
                  item.warn
                    ? _c(
                        "a-tooltip",
                        [
                          _c(
                            "template",
                            { slot: "title" },
                            _vm._l(item.warn.split(","), function (i) {
                              return _c("div", [_vm._v(_vm._s(i))])
                            }),
                            0
                          ),
                          _c(
                            "a-col",
                            {
                              staticStyle: {
                                "text-overflow": "ellipsis",
                                "white-space": "nowrap",
                                overflow: "hidden",
                              },
                              attrs: { span: item.warn > -1 ? 4 : 10 },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.warn) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }